import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

class SimpleTooltip extends React.Component {
  hasEnabled = message => {
    return message !== '';
  };

  render() {
    const {
      children,
      position,
      message,
      isLight,
      isI18n,
      appendClassName,
      appendStyle,
      alwaysShow,
    } = this.props;

    const messageI18n = isI18n ? I18n.t(message) : message;
    if (!messageI18n) {
      return children;
    }

    return (
      <Tooltip
        alwaysShow={alwaysShow}
        isLight={isLight}
        enabled={this.hasEnabled(messageI18n)}
        render={props => <div {...props}>{messageI18n}</div>}
        position={position}
        appendClassName={appendClassName}
        appendStyle={appendStyle}
      >
        {children}
      </Tooltip>
    );
  }
}

SimpleTooltip.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  position: PropTypes.string.isRequired, // top || left || right || bottom
  children: PropTypes.node.isRequired,
  isLight: PropTypes.bool,
  isI18n: PropTypes.bool,
  appendClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  appendStyle: PropTypes.object,
  alwaysShow: PropTypes.bool,
};

SimpleTooltip.defaultType = {
  isLight: false,
  isI18n: false,
  alwaysShow: false,
  message: '',
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(SimpleTooltip);
